import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Table } from "antd";
import { formatDisplayDate } from "../../utils/commonUtil";
const SubProjectHoldReasonInfo = ({ isModalOpen, handleOk, handleCancel, modalContent, title }) => {
    const columns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Reason',
            dataIndex: 'reason',
            key: 'reason',
            render: (text) => _jsx("span", { dangerouslySetInnerHTML: { __html: text } }),
        },
    ];
    const dataSource = [{
            key: 'stopReason',
            date: formatDisplayDate(modalContent === null || modalContent === void 0 ? void 0 : modalContent.dtstopReason),
            reason: modalContent === null || modalContent === void 0 ? void 0 : modalContent.strLongDesc,
        }];
    return (_jsx(Modal, { title: title, open: isModalOpen, onOk: handleOk, onCancel: handleCancel, children: _jsx(Table, { columns: columns, dataSource: dataSource }) }));
};
export default SubProjectHoldReasonInfo;
